import { types, Instance } from 'mobx-state-tree';

const { model, string, number, maybe, maybeNull } = types;

export const LicenseInfoModel = model('LicenseInfoModel', {
  aclPaymentDueDate: maybeNull(string),
  adminAccountState: maybeNull(string),
  dateAdminAccountPurchasedLicense: maybeNull(string),
  dateAdminAccountWasActivatedBySuperAdmin: maybeNull(string),
  dateRenewLicenseSubscription: maybeNull(string),
  lastPaymentReceivedDate: maybeNull(string),
  lastPaymentReceivedValue: maybeNull(string),
  licenseName: string,
  licensePrice: string,
  numberOfUsers: maybe(types.union(string, number)),
  sizeLicense: types.union(string, number),
  trial: number,
  serviceSelected: maybe(string),
  price: maybeNull(string),
  paidStatus: number,
});
export type ILicenseInfoModel = Instance<typeof LicenseInfoModel>;

export const AddonLicenseInfoModel = types.model('AddonLicenseInfoModel', {
  dateAddOnsBought: types.maybeNull(types.string),
  dateAddOnsExpire: types.maybeNull(types.string),
  paymentPriceUsersAddOn: types.maybeNull(types.union(types.string, types.number)),
  endUsers: types.maybeNull(types.number),
  name: types.maybeNull(types.string),
  dateLicensePurchased: types.maybeNull(types.string),
});

export type IAddonLicenseInfoModel = Instance<typeof AddonLicenseInfoModel>;
